import { create, open, } from 'utils/packages/plaid';
import { NativeModules, Platform } from 'react-native';
import Amplitude from './amplitude';
const { PlaidOAuthService } = NativeModules;
const startOAuthService = () => {
    if (Platform.OS === 'android' && PlaidOAuthService) {
        PlaidOAuthService.start();
    }
};
const stopOAuthService = () => {
    if (Platform.OS === 'android' && PlaidOAuthService) {
        PlaidOAuthService.stop();
    }
};
const onExit = (metadata) => {
    let eventName = 'ExitWithoutError';
    if (metadata && metadata.error) {
        eventName = 'ExitWithError';
    }
    stopOAuthService();
    Amplitude.logEvent(`PlaidLink.${eventName}`, metadata);
};
const onSuccessCb = (metadata, linkPlaidConnection, cb) => {
    const meta = metadata;
    stopOAuthService();
    Amplitude.logEvent('PlaidLink.Success', meta);
    Promise.resolve(linkPlaidConnection(meta)).then((response) => {
        const isSuccess = response && response.type === 'LINK_PLAID_CONNECTION_SUCCESS';
        if (isSuccess) {
            Amplitude.logEvent('PlaidLink.RedirectLoginSuccess', meta);
        }
        else {
            Amplitude.logEvent('PlaidLink.RedirectLoginFail', meta);
        }
        cb(isSuccess);
        return response;
    });
};
export const openPlaid = (getPlaidLink, linkPlaidConnection, cb) => {
    Promise.resolve(getPlaidLink()).then((response) => {
        if (response?.payload?.params?.token) {
            const onSuccess = (meta) => {
                onSuccessCb(meta, linkPlaidConnection, cb);
            };
            startOAuthService();
            create({ token: response.payload.params.token, noLoadingState: false });
            open({ onExit, onSuccess });
        }
        return response;
    });
};
export const openPlaidRenew = (data, linkPlaidConnection, cb) => {
    const onSuccess = (meta) => {
        onSuccessCb(meta, linkPlaidConnection, cb);
    };
    if (data?.payload?.params?.token) {
        startOAuthService();
        create({ token: data.payload.params.token, noLoadingState: false });
        open({ onExit, onSuccess });
    }
};
